import authSaga from './Authorization'

const runSagas = ({ run }) => {
  run(authSaga)
}


export default runSagas;
